import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import Add_ticket from './../../assets/images/add.png';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import Pagination from "react-js-pagination";
import $ from 'jquery';
class Reward extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            rewards: [],
            reward_detail: [],
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '',
            userEmail: has_local_data ? localdata.user_email : '',
            search: '',
            loading: 1,
            startDate: new Date(),
            endDate: new Date(),
            errors: {},
            isLoadMore: 1,
        };
        this.searchChange = this.searchChange.bind(this);
        this.handleChangeStart = this.handleChangeStart.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    handleRewardValidation() {
        let fields = this.state.reward_detail;
        let errors = {};
        let formIsValid = true;
        if (!fields["credit_reward"]) {
            formIsValid = false;
            errors["credit_reward"] = "This field is required.";
        }
        if (fields["credit_reward"] && !this.isValidNumber(fields["credit_reward"])) {
            formIsValid = false;
            errors["credit_reward"] = "Please Provide Numbers Only.";
        }
        if(this.state.reward_detail.is_credited == 2){
            if (fields["credit_reward"] && fields["credit_reward"] == 0){
                formIsValid = false;
                errors["credit_reward"] = "Redeem point should be greater than 0 and less than available reward points.";
            }
            if (fields["credit_reward"] && !this.checkRewardAvailability(fields["credit_reward"])) {
                formIsValid = false;
                errors["credit_reward"] = "Redeem point should be less than available reward points";
            }
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    checkRewardAvailability(reward_point){
        var available_reward_point = this.state.reward_detail.total_available_reward;
        if(Number(reward_point) > Number(available_reward_point)){
            return false;
        }else{
            return true;
        }
    }

    isValidNumber(number) {
        var pattern = /^[0-9]+$/;
        return pattern.test(number);
    }
    searchChange(event) {
        var obj = this;
        this.setState({ search: event.target.value,activePage: 1});
        //Delaying the function execute
        if (this.timer) {
            window.clearTimeout(this.timer);
    }
        this.timer = window.setTimeout(function () {
            //Execute the function code here...
            obj.rewardList();
        }, 500);
    }
    onChange(propertyName, event) {
        const reward_detail = this.state.reward_detail;
        reward_detail[propertyName] = event.target.value;
        this.setState({ reward_detail: reward_detail });
    }

    handleChangeStart(date) {
        this.setState({
            startDate: date,
            start_date: moment(date).format("YYYY-MM-DD")
        });
    }

    loadMorecount() {
        if (this.state.item_count > 0) {
            if (this.state.item_count >= 20) {
                if (this.state.isLoadMore != 2) {
                    if (this.state.isLoadMore == 1) {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="load_more" onClick={() => this.loadMore(this.state.activePage)}><span></span><span></span><span></span></div>
                            </div>
                        )
                    }
                    else {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="lds-ripple"><div></div><div></div></div>
                            </div>
                        )
                    }
                }
            }
        }
        else {
            return (
                <div className="text-center">No Data Found</div>
            )
        }
    }

    loadMore(pageNumber) {
        this.setState({ isLoadMore: 0 });
        pageNumber = pageNumber + 1;
        this.setState({ activePage: pageNumber });

        fetch(this.state.apiUrl + '/HrmanagementRest/RewardList/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey + '/page/' + pageNumber, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                if (findresponse.rewards.length == 0) {
                    this.setState({
                        isLoadMore: 2
                    });
                }
                else {
                    this.setState({
                        isLoadMore: 1
                    });
                }
                this.setState({
                    rewards: this.state.rewards.concat(findresponse.rewards),
                });

            });

    }

    handlePageChange(pageNumber = 1) {
        var totalPages = Math.ceil(this.state.item_count / 20);
        if (this.state.activePage != pageNumber) {
            $(document).ready(function () {
                $('.pages').addClass('disabled');
            });
            this.setState({ activePage: pageNumber, setPage: 'no' });
            fetch(this.state.apiUrl + '/HrmanagementRest/RewardList/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.decrypt(findresponse, 1);
                    $(document).ready(function () {
                        $('.pages').removeClass('disabled');
                        if (pageNumber == 1) {
                            $('.first_page').addClass('disabled');
                            $('.prev_page').addClass('disabled');
                        }
                        if (pageNumber == totalPages) {
                            $('.next_page').addClass('disabled');
                            $('.last_page').addClass('disabled');
                        }
                    });
                    this.setState({
                        rewards: findresponse.rewards,
                        offset: findresponse.offset,
                        off_count: findresponse.off_count,
                        setPage: 'yes'
                    });
                });
        }
    }

    rewardList(page = 1) {
        fetch(this.state.apiUrl + '/HrmanagementRest/RewardList/page/' + page + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    rewards: findresponse.rewards,
                    loading: 0,
                    item_count: findresponse.item_count,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    setPage: 'yes',
                    hr_permission:findresponse.hr_permission
                });
                if (this.state.rewards.date != '0000-00-00') {
                    this.setState({ startDate: new Date(this.state.rewards.date) })
                }
            });
    }

   /* delete_reward(id) {
        if (window.confirm('Are you sure you want to delete ?')) {
            fetch(this.state.apiUrl + '/HrmanagementRest/RewardDelete/id/' + id + '/userAuthKey/' + this.state.userAuthKey, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.decrypt(findresponse, 1);
                    this.setState({
                        activePage: 1,
                        rewards: [],
                    },
                        function () {
                            this.rewardList(this.state.activePage);
                        })
                })
        }
    }*/

    reward_details(id) {
        this.setState({ errors:{}});
        fetch(this.state.apiUrl + '/HrmanagementRest/RewardDetails/id/' + id + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    reward_detail: findresponse.reward_detail,
                });
                this.setState({ startDate: new Date(this.state.reward_detail.reward_date) });
            });
    }

    editrewardDetails(id) {
        if (this.handleRewardValidation()) {
            console.log("Data Has been submitted");
            //return true;
        } else {
            console.log("This Fields Are required.")
            return false;
        }
        document.getElementById("edit_reward_button").innerHTML = "Updating....";
        const fd = new FormData;
        fd.append('inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/HrmanagementRest/editRewardDetails/id/' + id + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                window.location.href = '/rewards';
            });
    }

    getUserRows() {
        let notes_length = 20;
        if (this.state.loading) {
            return (
                <div class="loader-new"></div>
            )
        } else {
            return (
                <div class="list_check">
                    <div class="tickets hidden-sm">
                        <ul class="tickets_head">
                            <li class="intra_col_25">Employee Name</li>
                            <li class="intra_col_13">Employee Id</li>
                            <li class="intra_col_15">Rewards</li>
                            <li class="intra_col_15">Date</li>
                            <li class="intra_col_25">Note</li>
                            <li class="intra_col_7">Action</li>
                        </ul>
                        {
                            this.state.rewards.map((rewards, key) =>
                                <ul class="tickets_number">

                                    <li class="intra_col_25"><Link key={key} to={`/viewLeaveReward/${rewards.employee_id}`} name={"max"}>{rewards.name}</Link></li>
                                    <li class="intra_col_13"><Link key={key} to={`/viewLeaveReward/${rewards.employee_id}`} name={"max"}>{rewards.muvi_employee_id}</Link></li>
                                    <li class={'intra_col_15 '+(rewards.is_credited == 2 ? 'text-danger' :'text-success')}>{rewards.is_credited == 2 ? <i class='fa fa-minus fa-thin text-danger'></i>:<i class='fa fa-plus fa-thin text-success'></i>} {rewards.credit_reward }</li>
                                    <li class="intra_col_15"> {rewards.date}</li>
                                    <li class="intra_col_25">
                                    {rewards.note ? 
                                    <p>{rewards.show_more ? rewards.note: rewards.note.substring(0,notes_length)} &nbsp;{(rewards.note.length > notes_length) ? <a class="view-more" onClick={() => this.showMoreNotes(key,rewards.show_more)}>{rewards.show_more ? "View Less":"View More"}</a> :""}</p>
                                    : '--'}
                                    </li>
                                    <li class="intra_col_7">
                                        <div class="edit_delete">
                                            <span class="edit" onClick={() => this.reward_details(rewards.id)} data-toggle="modal" data-target="#editReward"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></span>
                                            {/*<span class="delete" onClick={() => this.delete_reward(rewards.id)}><i class="fa fa-trash" aria-hidden="true"></i></span>*/}
                                        </div>
                                    </li>
                                </ul>

                            )
                        }
                    </div>
                    {this.state.rewards.map((rewards, key) =>

                            <div class="customer_mob hidden-md">
                                <div class="custmer_list_mob">
                                    <Link key={key} to={`/viewLeaveReward/${rewards.employee_id}`} name={"max"}>
                                        <div>{rewards.name ? rewards.name : '--'}</div>
                                    </Link>
                                    <Link key={key} to={`/viewLeaveReward/${rewards.employee_id}`} name={"max"}>
                                        <div class="wrap">{rewards.credit_reward + " Points"}</div>
                                    </Link>
                                    <div tabindex="0" class="onclick-menu pull-right">
                                        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                        <ul class="onclick-menu-content">
                                            <li onClick={() => this.reward_details(rewards.id)} data-toggle="modal" data-target="#editReward"><a>Edit</a></li>
                                            {/*<li onClick={() => this.delete_reward(rewards.id)}><a>Delete</a></li>*/}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        )}
                    {this.state.item_count > 0 ? <div class="pagination-muvi">
                        <Pagination
                            itemClass={'pages'}
                            itemClassFirst={'first_page'}
                            itemClassPrev={'prev_page'}
                            itemClassNext={'next_page'}
                            itemClassLast={'last_page'}
                            activePage={this.state.activePage}
                            itemsCountPerPage={20}
                            totalItemsCount={this.state.item_count}
                            pageRangeDisplayed={5}
                            onChange={this.state.setPage == 'yes' ? this.handlePageChange : ''}
                        />
                        <div style={{ color: "#333" }}>
                            {(this.state.offset + 1) + ' - ' + (this.state.offset + this.state.off_count)} of {this.state.item_count}
                        </div>
                    </div> : <div className="text-center" style={{ color: "#333" }}>No Data Found</div>}
                    {/* {this.loadMorecount()} */}
                </div>
            )
        }
    }


    componentDidMount() {
        document.title = "Intranet | Reward";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.rewardList();
    }

    showMoreNotes(reward_key,show_flg){
        var reward_list = this.state.rewards;
        reward_list[reward_key]['show_more'] = show_flg ? 0 :1;
        this.setState({rewards:reward_list});
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        if (this.state.hr_permission == 'no') {
            return (
                        <Redirect to={'/home'} />
                    )
        }
        return (
            <div>
                <Header brecum_name="Rewards" brecum_page="Rewards" />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="title mob hidden-sm">
                            <span>Rewards</span>

                        </div>
                        <div class="top-row">
                            <div class="right-section pull-right">
                                <div class="row">
                                    <div class="col-md-12 col-xs-12">
                                        <div class="searchTicket mob_customer">
                                            <input type="text" class="form-control" name="search" id="search" placeholder="Search By Name Or Employee Id" onChange={this.searchChange} /><button type="submit"><i class="fa fa-search"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <--modal start for edititng Leave-!> */}
                            <div class="modal fade" id="editReward" role="dialog">
                                <div class="modal-dialog modal-md">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                                            <h4 style={{ color: "black" }} class="modal-title">Update Rewards</h4>
                                        </div>
                                        <div class="modal-body">
                                            Employee Name
                <input type="text" class="form-control" name="emp_name" placeholder="Employee Name" value={this.state.reward_detail.name} disabled />
                                            <br></br>
                                            Employee Id
                <input type="text" class="form-control" name="emp_muvi_id" placeholder="Employee Id" value={this.state.reward_detail.muvi_employee_id} disabled />
                                            <br></br>
                                            Reward Points {this.state.reward_detail.is_credited == 2 ? `(Available - ${this.state.reward_detail.total_available_reward})`:""}
                <input type="text" class="form-control" name="credit_reward" placeholder="Credit Reward" value={this.state.reward_detail.credit_reward} onChange={this.onChange.bind(this, 'credit_reward')} />
                                            <span class="error">{this.state.errors["credit_reward"]}</span>
                                            <br></br>
                                            Date
                <DatePicker
                                                selected={this.state.startDate !="Invalid Date" ? this.state.startDate:new Date()}
                                                selectsStart
                                                startDate={this.state.startDate}
                                                //endDate={this.state.endDate}
                                                onChange={this.handleChangeStart}
                                                onKeyDown={e => e.preventDefault()}
                                                dateFormat="dd/MM/yyyy"
                                            />
                                            <br></br>
                                            Notes
                <textarea type="text" name="note" class="form-control" onChange={this.onChange.bind(this, 'note')} value={this.state.reward_detail.note}></textarea>
                                        </div>

                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-blue" data-dismiss="modal">Cancel</button>
                                            <button type="button" class="btn btn-sky" id="edit_reward_button" onClick={() => this.editrewardDetails(this.state.reward_detail.id)}>Update</button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <--modal end for editng Leave-!> */}
                        </div>
                        {this.getUserRows()}
                    </div>
                </div>
            </div>
        )
    }
}
export default Reward;


// WEBPACK FOOTER //
// ./src/components/hrAdmin/rewards.js